import knowledgeTableFatherDlg from './src/main.js'
export default knowledgeTableFatherDlg



// WEBPACK FOOTER //
// ./src/components/knowledgeTableFatherDlg/index.js